"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var core_1 = require("@material-ui/core");

var form_1 = require("./form");

var popover_filter_1 = __importDefault(require("./popover-filter"));

var FilterUnit = function FilterUnit(props) {
  var filter = props.filter,
      filters = props.filters,
      name = props.name,
      _onChange = props.onChange;

  if (typeof filter === 'boolean' && filter === true) {
    return react_1.default.createElement(popover_filter_1.default, {
      isActive: filters[name]
    }, react_1.default.createElement(form_1.SearchUnit, {
      name: name,
      value: filters[name],
      onChange: function onChange(v) {
        return _onChange({
          name: name,
          value: v.value
        });
      }
    }));
  }

  if (typeof filter === 'object' && filter.type === 'string') {
    return react_1.default.createElement(popover_filter_1.default, {
      isActive: filters[name]
    }, react_1.default.createElement(form_1.SearchUnit, {
      name: name,
      value: filters[name] ? filters[name].value.value : '',
      onChange: function onChange(v) {
        _onChange({
          name: name,
          value: {
            value: v.value,
            func: filter.func
          }
        });
      },
      placeholder: "Type to filter..."
    }));
  }

  if (typeof filter === 'object' && Array.isArray(filter.options)) {
    if (filter.type === 'category') {
      var v = filters[name] ? filters[name].value : [];
      return react_1.default.createElement(popover_filter_1.default, {
        isActive: filters[name]
      }, react_1.default.createElement(core_1.FormControl, {
        component: "fieldset"
      }, react_1.default.createElement(core_1.FormGroup, null, filter.options.map(function (option, i) {
        return react_1.default.createElement(core_1.FormControlLabel, {
          key: i,
          value: option.key,
          control: react_1.default.createElement(core_1.Checkbox, {
            checked: v.includes(option.key),
            onChange: function onChange() {
              return _onChange({
                name: name,
                value: {
                  value: option.key,
                  func: filter.func
                },
                type: filter.type
              });
            }
          }),
          label: option.value
        });
      }))));
    }

    if (filter.type === 'select') {
      var value = filters[name] ? filters[name].value.value : '';
      return react_1.default.createElement(popover_filter_1.default, {
        isActive: filters[name]
      }, react_1.default.createElement(core_1.FormControl, {
        component: "fieldset"
      }, react_1.default.createElement(core_1.RadioGroup, {
        "aria-label": name.toString(),
        value: value
      }, filter.options.map(function (option, i) {
        return react_1.default.createElement(core_1.FormControlLabel, {
          key: i,
          value: option.key,
          style: {
            marginRight: 0
          },
          control: react_1.default.createElement(core_1.Radio, {
            onChange: function onChange() {
              return _onChange({
                name: name,
                value: {
                  value: option.key,
                  func: filter.func
                },
                type: filter.type
              });
            }
          }),
          label: option.value
        });
      }))));
    }
  }

  return null;
};

exports.default = FilterUnit;